export default {
  title: "Размещение в каталоге",
  untilDeadline: "Не позднее {date}",
  deadlineInfo:
    "Обращаем Ваше внимание, что если информация в каталог не предоставлена до {date} включительно, во всех официальных изданиях выставки (каталоге, путеводителе и интерактивном каталоге-путеводителе) будет опубликовано только название компании, страна и номер стенда.",
  startDate: "Доступно с {date}",
  unavailable: "Подача заявок в Личном кабинете недоступна",
  deadlinePassed: "Подача заявок в Личном кабинете завершена",

  confirmClose:
    "Заявка в каталог не отправлена. Вы точно хотите закрыть заявку в каталог?",

  betweenEndOrderAndPrintStart: "Вы можете отправить заявку в течение 1 дня",

  orderSent: "Отправлена",
  orderNotSent: "Не отправлена",
  orderModeration: "Принята на модерацию",
  orderAccepted: "Принята на публикацию в каталоге",

  sendBtn: "Заполнить заявку",
  sendAgree: "Отправляя заявку вы соглашаетесь с",
  termsPart1: "Общие условия",
  termsPart12: "Общими условиями",
  termsPart2:
    "размещения рекламно-информационных материалов в официальном каталоге-путеводителе выставки",

  colorgNotification: "Размещение в каталоге коллективного организатора",

  hasCatalogOrder1cMessage:
    "Информация введена менеджером, ответственным за каталог",
  modal: {
    spellerButton: "Проверить орфографию",
    spellerNote1: "Проверка правописания: ",
    spellerNote2: "Яндекс.Спеллер",
    infoTogglerTitle: "Информация о размещении в каталоге",
    managerTitle: "Есть вопросы? Обратитесь к менеджеру:",
    errorPriceServices:
      "N/A&nbsp;&mdash; для некоторых услуг не&nbsp;определена стоимость. Пожалуйста, обратитесь к&nbsp;менеджеру.",
    errorPriceService:
      "Для выбранной услуги не&nbsp;определена стоимость. Пожалуйста, обратитесь к&nbsp;менеджеру.",

    nav: {
      alphabetList: "Алфавитный список участников",
      rubrics: "Рубрикатор",
      rubricsPackages: "Пакетное размещение в рубрикаторе", // for preview
      russianExporter: "Российский экспортер",
      packagePlacement: "Пакетные размещения",
      packagePlacementLogo: "Размещение логотипа", // for preview
      adService: "Рекламные услуги",
      preview: "Предварительный просмотр заявки",
      backBtn: "Назад"
    },

    alphabetList: {
      basicInfoHelp: "Базовая информация о компании подтягивается из",
      basicInfoLink: "профиля",
      basicInfo: "Основная информация",
      requiredFields: "Обязательные поля",

      companyNameForBooklet:
        "Официальное название компании и/или торговой марки",
      companyCountryForBooklet: "Страна для списка по странам",

      additionalFields: "Пример стандартной информации в каталоге",

      companyNameEng: "Наименование компании на английском",
      companyNameEngValid:
        "В поле «Наименование компании на английском» присутствуют недопустимые символы. Поле не должно содержать букв русского алфавита.",
      companyOwnerType: "Форма собственности",
      companyCountry: "Страна",
      companyRussianExporter: "Российский экспортер",
      stands: "Стенды",
      companyStand: "Номер стенда",
      invalidCompanyStand: "Указан некорректный номер стенда",
      extraCompanyStand: "Дополнительный номер стенда",
      companyAddress: "Адрес компании",
      extraCompanyAddressForRubric: "Дополнительный адрес в рубрике",
      extraCompanyAddress: "Дополнительный адрес компании",
      companyWebsite: "Сайт",
      companyEmail: "Email",
      companyPhone: "Телефон компании",
      companyFax: "Факс",
      companyInfoTitle: "Сведения о деятельности компании",
      companyInfo:
        "Сведения о деятельности компании на русском языке (перевод)",
      companyInfoEng: "Сведения о деятельности компании на английском языке",
      companyInfoResident: "Сведения о деятельности компании на русском языке",
      companyInfoEngResident:
        "Сведения о деятельности компании на английском языке (перевод)",
      companyInfoPlaceholder:
        "До {freeAmount} символов входят в стоимость участия в выставке, каждые последующие {stringLength} — {price} {currencySymbol}",
      companyInfoEngPlaceholder:
        "Текст должен являться переводом сведений о деятельности фирмы",
      companyInfoCounting:
        "  Подсчет стоимости ведется по полю «Сведения о деятельности компании на английском языке».",
      companyInfoCountingIsResident:
        "  Подсчет стоимости ведется по полю «Сведения о деятельности компании на русском языке».",
      exporter:
        "Внести в раздел «Российский экспортер / заинтересован в экспорте»",
      importSubstitution: "Внести в раздел «Импортозамещение»",

      additionalSymbols: "Дополнительные {amount} символов",
      letterNote: "под этой буквой будет отображаться наименование в каталоге",
      totalSymbolsAmount: "Общее количество символов:",
      freeSymbols: "Бесплатных:",
      extraSymbols: "Платных:",
      addExtraAddress: "Добавить ещё адрес",
      addExtraCompanyStand: "Добавить номер стенда",

      errors: {
        companyInfoRus:
          "Сведения о деятельности компании должны быть заполнены на русском языке",
        companyInfoEng:
          "Сведения о деятельности компании должны быть заполнены на английском языке"
      }
    },

    rubricator: {
      rubricsTitle: "Рубрики",
      rubricsFreeNote: "в стоимость участия входит краткая информация в",
      rubricsFreeNotePluralize: ["рубрике", "рубриках", "рубриках"],

      chosenNote: "Выбрано:",

      chooseRubricsBtn: "Выбрать рубрики",
      addRubricBtn: "Добавить рубрику",

      forAllTitle: "Для всех выбранных рубрик",
      packagePlacement: "Пакетные размещения",
      packagePlacementPrimary: "применяются автоматически",

      footerLastStepPleaseSelect:
        "Для того, чтобы продолжить, выберите хотя бы одну рубрику",
      footerPaidServices: "Платные услуги",

      countPaidRubrics: [
        "платная рубрика",
        "платные рубрики",
        "платных рубрик"
      ],

      countRubrics: ["рубрика", "рубрики", "рубрик"],
      countSelectedPakage1: "Выбран {count} пакет по {price}",
      countSelectedPakage3_4: "Выбрано {count} пакета по {price}",
      countSelectedPakage5_20: "Выбрано {count} пакетов по {price}"
    },

    russianExporterList: {
      title: "Специальный раздел «Российский экспортер»",
      subtitle: "(Входит в стоимость участия)",
      primary:
        "Бланк заполняется только российскими компаниями, поставляющими продукцию на зарубежные рынки.",

      searchPlaceholder: "Найти рубрику",

      footerAllRubrics: "Всего рубрик:",
      footerPaidRubrics: "Платных:",
      footerSelectBtn: "Выбрать",

      printRubrics: "Распечатать"
    },

    rubricsSelect: {
      title: "Выбор рубрик",

      freeNote: "В стоимость участия входит краткая информация в",
      freeNotePluralize: ["рубрике", "рубриках", "рубриках"],

      suggestBtn: "Предложить новую рубрику",
      suggestFormText:
        "Если Вы не нашли нужную Вам рубрику, то напишите название нужной рубрики ниже и в ближайшее время мы добавим ее в каталог, или свяжитесь с отделом каталогов по телефону 8 800 707 37 99",
      suggestFormPlaceholder: "Название рубрики",

      suggestionSuccess: "Предложение принято",

      searchPlaceholder: "Найти рубрику",

      printRubrics: "Распечатать",

      footerAllRubricsSelected: "Всего рубрик:",
      footerPaidRubricsSelected: "Платных:",
      footerSelectBtn: "Выбрать"
    },

    logo: {
      title: "Логотип компании (для платных услуг)",
      description:
        "В форматах Adobe Illustrator CS4, а также BMP, TIFF (натуральный размер с разрешением не менее 300 точек на дюйм)",

      loadBtn: "Загрузить",
      destroyBtn: "Удалить",
      changeBtn: "Изменить",
      loadingBtn: "Загружаем {filename}",

      orderLogoImageAlt: "Загруженный логотип компании для выставки",
      companyLogoImageAlt: "Логотип компании для выставки из профиля компании",
      noLogoImageAlt: "Нет загруженного логотипа для выставки",

      errors: {
        base64Encoding: "Ошибка кодирования изображения",
        fileTooBig: "Вы загрузили слишком большой файл",
        incorrectFileFormat: "Неверный формат файла",
        cantSaveFile: "Не удалось сохранить логотип",
        cantSaveInfo: "Не удалось обновить информацию о логотипе"
      }
    },
    cover: {
      title: "Изображение-обложка  (для платных услуг)",
      description: "В форматах JPG, JPEG, PNG: 1920х720 px.",
      presentationFileTitle: "Файл презентации (для платных услуг)",
      videoLinkTitle: "Ссылка на видеоролик (для платных услуг)",
      presentationFileDescription: "В формате PDF",
      videoLinkPlaceholder: "Укажите ссылку на видео (rutube, vk видео)"
    },
    packageServices: {
      logoPlacementTitle: "Логотипы и модули",
      majorServicesTitle: "Пакетные услуги",
      additionalServicesTitle: "Дополнительные услуги"
    },

    adServices: {
      adInCatalogTitle: "Рекламная услуга в каталоге",
      adInGuideTitle: "Рекламная услуга в путеводителе",
      adInOtherTitle: "Прочие рекламные услуги",

      noAdServicesMessage: "Нет рекламных услуг.",

      additionalApprovalNote:
        "Требует дополнительного согласования с отделом каталогов размещение рекламы на обложках и в колонтитулах каталога и путеводителя.",

      graphicFiles: "Графические файлы (для платных услуг)",
      graphicFilesFormats: "В форматах JPG, JPEG, PNG или архив ZIP формата.",
      graphicFilesPrimary:
        "Вы можете указать ссылку на файлообменник с дополнительныеми графическими файлами"
    },

    footer: {
      total: "Сумма услуг:",
      totalVAT: "Сумма услуг с НДС (20%):",
      nextBtn: "Продолжить",
      backBtn: "Назад",
      sendBtn: "Отправить",
      closeBtn: "Закрыть",

      submitAgreeMessage: "Вы уверены, что хотите отправить заявку?",
      submitSuccessMessage: "Заявка успешно отправлена!"
    },

    preview: {
      changeBtn: "Изменить",
      companyLetter: "Компания под буквой в списке",
      standNumber: "Номер стенда",

      additionalSymbols: "Дополнительные {amount} символов в описании:",
      additionalEngSymbols:
        "Дополнительные {amount} символов в описании на английском языке:",
      additionalAddresses: "Дополнительные адреса компании:",
      additionalRubricAddresses: "Дополнительные адреса:",

      majorPackagePrice: "Стоимость пакета:",
      additionalPackagePrice: "Стоимость дополнительного пакета:",
      servicesPrice: "Стоимость услуг:",
      rubricPrice: "Стоимость рубрики:",
      adServicePrice: "Стоимость рекламного размещения:",

      adServiceCatalog: "Рекламный блок в каталоге",
      adServiceGuide: "Рекламный блок в путеводителе",
      adServiceOther: "Прочие рекламные услуги",

      downloadOrder: "Скачать заявку",

      notServicesWithLogo:
        "Не выбрана ни одна услуга с логотипом (логотип не будет размещен)",
      notServiceAdditional:
        "Не выбрана ни одна услуга с рекламным модулем (файлы не будут размещены)",
      notServicesWithCoverFiles:
        "Выбрана услуга рекламного модуля, но файлы не загружены",
      notLogoForServices: "Выбраны услуги с логотипом, но не загружен логотип",
      notLinkGraphicFiles:
        "Выбраны услуги с рекламой, но не указаны графические файлы",

      documents: {
        requiredField: "Обязательное поле",
        infoOrder:
          "При заказе платных услуг прикрепите заявку с&nbsp;печатью и&nbsp;подписью в&nbsp;формате PDF (не более 5Мб)",
        infoRequisites: "Прикрепите реквизиты плательщика в&nbsp;формате DOCX",
        upload: "Загрузить",
        downloadFile: "Скачать файл",
        errorSize:
          "Файл слишком большой ({filesize}Mb). Максимальный размер файла: {maxFilesize}Mb.",
        errorAccepted:
          "Ошибка загрузки файла: допустимые форматы файлов - {acceptedFiles}"
      }
    }
  }
};
